module.exports = "<ion-content>\n  <app-reports-card [commonData] = 'statusReportData' [report] = 'reportName'></app-reports-card>\n</ion-content>"